import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { couponSchema } from "./coupon";

const createCouponSchema = couponSchema
  .pick({
    reduction: true,
    userId: true,
    startDate: true,
    type: true,
    rateId: true,
    status: true,
  })
  .extend({
    // endDate optionnelle : si fournie, remplace le calcul +6 mois par défaut.
    // Utilisée par les coupons Marketing à durée limitée (ex: campagne 24h).
    endDate: z.coerce.date().optional(),
  });

export class CreateCouponDto extends createZodDto(createCouponSchema) {}
